import { render, staticRenderFns } from "./peopleOutdated.vue?vue&type=template&id=ad8958a4&"
import script from "./peopleOutdated.vue?vue&type=script&lang=ts&"
export * from "./peopleOutdated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports